import { type InputHTMLAttributes, type SelectHTMLAttributes } from "react";
import {
  CONTROL_BASE,
  CONTROL_INVALID,
  CONTROL_SIZE,
  SELECT_SIZE,
  selectChevron,
} from "./tokens";

// 폭은 className 이 아니라 fullWidth 로 고른다 — CONTROL_BASE 에 w-full 을 넣으면
// 호출처의 w-64 와 특이도가 같아 Tailwind 생성 순서에 밀려 무시된다.
// sizing 도 같은 이유로 프롭이다 (px-3 vs px-2 충돌 방지).
type ControlProps = {
  sizing?: keyof typeof CONTROL_SIZE;
  fullWidth?: boolean;
};

// HTML 의 size 속성(number)과 이름이 겹치지 않게 sizing 을 쓴다
export function Input({
  sizing = "md",
  fullWidth = true,
  invalid = false,
  className = "",
  ...rest
}: ControlProps & {
  invalid?: boolean;
} & InputHTMLAttributes<HTMLInputElement>) {
  return (
    <input
      className={`${CONTROL_BASE} ${CONTROL_SIZE[sizing]} ${
        fullWidth ? "w-full" : ""
      } ${invalid ? CONTROL_INVALID : ""} ${className}`}
      {...rest}
    />
  );
}

// 크기는 CONTROL_SIZE 가 아니라 SELECT_SIZE 를 쓴다 — 오른쪽에 chevron 자리를 비워야 해서
// 좌우 padding 이 다르다. style 은 rest 에서 빼내 병합한다: {...rest} 로 흘려보내면
// 호출처가 style 을 주는 순간 chevron 배경이 통째로 날아간다.
// disabled 도 빼낸다 — chevron 색을 갈라야 해서 값이 필요하고, 뺀 만큼 다시 넘겨준다.
export function Select({
  sizing = "md",
  fullWidth = true,
  className = "",
  style,
  disabled,
  children,
  ...rest
}: ControlProps & SelectHTMLAttributes<HTMLSelectElement>) {
  return (
    <select
      className={`${CONTROL_BASE} ${SELECT_SIZE[sizing]} appearance-none ${
        fullWidth ? "w-full" : ""
      } ${className}`}
      style={{ ...selectChevron(sizing, disabled), ...style }}
      disabled={disabled}
      {...rest}
    >
      {children}
    </select>
  );
}
